<template>
  <section id="main-header-wrapper" :class="{ full }">
    <video
      autoplay
      loop
      playsinline
      muted
      class="main-header-video desktop-only"
    >
      <source src="/img/dayz-hero.mp4" type="video/mp4" />
      Your browser can not play the provided video file.
    </video>

    <img
      src="/img/mobil-view-big.jpg"
      alt="DayZ Badlands image"
      class="main-header-img mobile-only"
    />

    <container class="wrapper-container">
      <header id="main-header">
        <div id="logo" style="z-index: 99;">
          <router-link :to="{ name: 'home' }">
            <img
              src="./../../public/img/logos/dayz-logo-small.png"
              alt="DayZ"
            />
          </router-link>
        </div>
        <div id="main-header-account" style="z-index: 99;">
          <span id="main-header-divider">/</span> THIS IS YOUR STORY
        </div>
      </header>

      <template v-if="full">
        <section>
          <header id="main-content-header" style="z-index: 99;"></header>
          <div>
            <div class="centered-button">
              <a
                href="https://store.steampowered.com/app/3816030"
                target="_blank"
                rel="noopener"
                class="hero-button"
              >
                <img
                  src="../assets/icons/steam-icon-hero.png"
                  alt="Steam icon"
                  class="icon"
                />
                <img
                  src="../assets/icons/text-button-hero.png"
                  alt="Wishlist Now"
                  class="label"
                />
              </a>
            </div>
          </div>
        </section>
      </template>
    </container>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import steamLogo from "../assets/icons/steam.svg";
import xboxLogo from "../assets/icons/xbox.svg";
import psnLogo from "../assets/icons/psn.svg";

export default {
  name: "landing-page",
  data() {
    return {
      full: false,
      steamLogo,
      xboxLogo,
      psnLogo,
    };
  },
  methods: {
    toggleForm() {
      if (!this.isSubscribed) {
        if (!this.isLogged) {
          location.href = "/api/auth/login?show=true";
        } else {
          this.$emit("toggleForm");
        }
      }
    },
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.full = newVal.path === "/";
      }
    },
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      isLogged: "isLogged",
      loading: "loading",
    }),
  },
};
</script>

<style scoped lang="scss">
@import "./../assets/styles/splash";
@import "./../assets/styles/vars";

$sizes: 320 480 600 800 1024 1280 1440 1600 1920 2048;

#main-header-wrapper {
  width: 100%;
  padding: 60px 0;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  min-height: 400px;
  max-height: 1800px;
  height: 42vw;

  @media (max-width: 1400px) {
    font-size: 0.9em;
  }

  @media (max-width: 1200px) {
    font-size: 0.7em;
  }

  @each $size in $sizes {
    @media (max-width: $size) {
      background-image: url("./../../public/img/splash/bg_small.jpg?size="+$size);
    }
  }
}

.main-header-video,
.main-header-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.mobile-only {
  display: none;

  @media (max-width: 1023px) {
    display: block;
  }
}

.desktop-only {
  display: block;

  @media (max-width: 1023px) {
    display: none;
  }
}

#main-header {
  display: flex;
  align-items: center;
  letter-spacing: 2px;
}

#logo {
  margin-right: 2em;

  img {
    width: 100%;
    max-width: 100px;
    height: auto;
  }
}

#main-content-wrapper {
  padding: 120px 0;
  z-index: 99;
}

#main-content {
  position: relative;
  padding: 1em 0 0;
  display: flex;
  flex-direction: column;
}

.centered-button {
  position: absolute;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  transition: all 300ms ease-in-out;
}

@media (min-width: 1024px) {
  .centered-button {
    bottom: 6vh;
  }
}

.hero-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 284px;
  height: 100px;
  padding: 0 20px;
  background-image: url("../assets/icons/bg-button-hero.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 300ms ease-in-out;
  overflow: hidden;
  border-radius: 8px;

  &:hover {
    transform: translateY(-4px);
  }

  .icon {
    flex: 1;
    max-width: 20%;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  .label {
    flex: 2;
    max-width: 80%;
    max-height: 60px;
    height: auto;
    object-fit: contain;
    padding-left: 15px;
  }
}
</style>
